import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.locationIdField = document.getElementById('location_id');
    this.locationIdField.addEventListener('change', this.goToHospital.bind(this));
  }

  goToHospital() {
    if (this.locationIdField.value != '') {
      var newPath = window.location.pathname + this.locationIdField.value;
      window.location.href = newPath;
    }
  }
}